// extracted by mini-css-extract-plugin
export default {"comment-adding":"CommentAdding_comment-adding__KiWYV","comment-input":"CommentAdding_comment-input__Fx9oz","send-button":"CommentAdding_send-button__1bxZ3"};